export function formatTime (value) {
  if (!value) return '—'
  const date = new Date(value)
  if (!Number.isFinite(date.getTime())) return String(value)
  return new Intl.DateTimeFormat('zh-CN', { timeZone: 'Asia/Shanghai', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }).format(date).replaceAll('/', '-') + '（北京时间）'
}
export function statusLabel (value) {
  return ({ ENABLED: '启用', DISABLED: '停用', IN_PROGRESS: '进行中', PAUSED: '已暂停', NOT_STARTED: '未开始', SUBMITTED: '已提交', ENDED: '已终止', EXPIRED: '已过期', RESET: '已重置', REOPENED: '已重开', PUBLISHED: '已发布', DRAFT: '草稿' })[value] || value || '—'
}
